import React from "react";
import "./Projects.css";

const projects = [
  {
    title: "Calendar Management",
    description:
      "Managed and organized executive schedules, ensuring smooth operations.",
    tools: "Google Calendar, Outlook, Calendly",
    image: "/Calendar Management.png",
  },
  {
    title: "Email Management",
    description:
      "Handled inboxes, prioritized emails, and ensured timely responses.",
    tools: "Gmail, Outlook, Filters, Templates",
    image: "/Email Management.png",
  },
  {
    title: "Data Entry",
    description:
      "Accurately inputted and organized large datasets to improve efficiency.",
    tools: "Excel, Google Sheets, CRM Systems",
    image: "/Data Entry Poject.PNG",
  },
];

const Projects = () => {
  return (
    <section className="projects-container">
      <h2 className="projects-heading">Projects</h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <img src={project.image} alt={project.title} className="project-image" />
            <h3 className="project-title">{project.title}</h3>
            <p className="project-description">{project.description}</p>
            <p className="project-tools"><strong>Tools Used:</strong> {project.tools}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
